/** On the advert search: the agent being edited, whose filters the URL carries. */
export const SEARCH_AGENT_PARAM = 'agent';

// ponytail: hardcoded until the pages get link fields.
export const SEARCH_AGENTS_PAGE_URL = '/profil/bolig-agenter/';
export const SEARCH_PAGE_URL = '/find-ny-bolig';

/** Search component fields for the save button and dialog on the advert search. */
export type SearchAgentTexts = {
    createButtonText?: string | null;
    cancelButtonText?: string | null;
    filterSearchPlaceholder?: string | null;
    saveChangesButtonText?: string | null;
    dialogTitle?: string | null;    
    dialogIntroHtml?: string | null;
    nameLabel?: string | null;
    submitButtonText?: string | null;
    savedTitle?: string | null;
    savedHtml?: string | null;
    goToAgentsText?: string | null;
    errorText?: string | null;
};
